import { useState, useCallback } from 'react';
import { message } from 'antd';
import { getApiService } from '../../../shared/services/api/api.service';
import { useAuthContext, decodeJwt } from '../../../shared/contexts/AuthContext';

export const useLogin = () => {
  const { setAuthState } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const login = useCallback(
    async (username: string, password: string): Promise<boolean> => {
      setIsLoading(true);
      setError(null);

      try {
        console.log('Attempting login via useLogin for user:', username);

        const response = await getApiService().login({ username, password });
        console.log('Login response received in useLogin:', response);

        // Check if login was successful
        if (!response.success) {
          throw new Error('Login failed');
        }

        // Extract token from response
        const token = response.token;

        if (!token) {
          throw new Error('No token received in response');
        }

        // Decode JWT to get user info
        const decodedToken = decodeJwt(token);

        if (decodedToken) {
          // Update AuthContext state - use decoded token data
          // Default role to 'user' if not present in token
          const role = decodedToken.role || 'user';
          setAuthState(token, decodedToken.username, role);
          console.log('Login successful via useLogin - Auth state updated.');
          message.success('Login successful');
          return true;
        } else {
          throw new Error('Invalid token received');
        }
      } catch (err: any) {
        console.error('Login error in useLogin:', err);
        const errorMessage =
          err.response?.data?.message || err.message || 'Failed to login';
        setError(errorMessage);
        message.error(errorMessage);
        return false;
      } finally {
        setIsLoading(false);
      }
    },
    [setAuthState],
  );

  return { login, isLoading, error };
};
